import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";
import ServiceChecks from "../../components/global/ServiceChecks";

const OVERVIEW = [
    "Cloud migration done badly is expensive and disruptive. We plan and execute migrations carefully — assessing what to move, how and when — then manage the environment once you're there.",
    "The result is infrastructure that's more flexible and cost-efficient, without the downtime and surprises that come from rushing the move.",
];

const FEATURES = [
    { title: "Migration planning", text: "A clear assessment and roadmap before anything moves." },
    { title: "Smooth execution", text: "Careful, staged migration that minimises downtime and risk." },
    { title: "Cost optimisation", text: "Right-sized resources so you don't pay for capacity you don't use." },
    { title: "Ongoing management", text: "Monitoring, scaling and maintenance of your cloud environment." },
];

const CHECKS = [
    "Cloud readiness assessment",
    "Migration planning & execution",
    "Cost optimisation",
    "Cloud monitoring & management",
    "Backup & disaster recovery",
];

export default function ManagedCloudMigrationServices() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Server & Networking" title="Managed Cloud & Migration" eyebrowAs="span">
                    Move to the cloud with confidence — planned migrations and ongoing management that cut risk and cost.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceChecks title="What's included" items={CHECKS} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
